/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_ManagementInputs */

const en_team_management = /** @type {(inputs: Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Management`)
};

const fr_team_management = /** @type {(inputs: Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion d'équipe`)
};

const de_team_management = /** @type {(inputs: Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teammanagement`)
};

const it_team_management = /** @type {(inputs: Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione del team`)
};

const ru_team_management = /** @type {(inputs: Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление командой`)
};

const es_team_management = /** @type {(inputs: Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de equipos`)
};

const zh_cn2_team_management = /** @type {(inputs: Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`团队管理`)
};

const ja_team_management = /** @type {(inputs: Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームマネジメント`)
};

const hi_team_management = /** @type {(inputs: Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम प्रबंधन`)
};

const pt_pt2_team_management = /** @type {(inputs: Team_ManagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestão de Equipes`)
};

/**
* | output |
* | --- |
* | "Team Management" |
*
* @param {Team_ManagementInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_management = /** @type {((inputs?: Team_ManagementInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_ManagementInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_management(inputs)
	if (locale === "de") return de_team_management(inputs)
	if (locale === "it") return it_team_management(inputs)
	if (locale === "ru") return ru_team_management(inputs)
	if (locale === "es") return es_team_management(inputs)
	if (locale === "zh-CN") return zh_cn2_team_management(inputs)
	if (locale === "ja") return ja_team_management(inputs)
	if (locale === "hi") return hi_team_management(inputs)
	if (locale === "pt-PT") return pt_pt2_team_management(inputs)
	return en_team_management(inputs)
});